export const Spinner = () => {
  return (
    <div
      className="spinner-border spinner-border-sm text-warning mx-auto"
      id="spinner"
      role="status"
      style={{ display: "none", margin: "2px", overlay: "zIndex: 1000" }}
    ></div>
  );
};
